/* =====================================================================
   BACK IN STOCK (Appikon) — reposition the "Notify Me" button  07/30/26
   Re-applied 10/23/26.

   Appikon appends #SI_trigger to the end of .product-single__form, below the
   promo box and trust list. This moves it directly after the Add to Cart
   block. The button is injected asynchronously (6-12s after load), so this
   watches for it rather than running once.
   ===================================================================== */

(function () {
  'use strict';

  if (document.body && document.body.className.indexOf('template-product') === -1) return;

  var TRIGGER = '#SI_trigger';
  var ANCHOR = '.product-single__form .product-single__add-to-cart';

  function reposition() {
    var btn = document.querySelector(TRIGGER);
    var anchor = document.querySelector(ANCHOR);

    if (!btn || !anchor) return false;

    /* Already in place — stops the observer looping on its own change. */
    if (btn.previousElementSibling === anchor) return true;

    /* Only reorder within the form Appikon chose. */
    if (btn.parentElement !== anchor.parentElement) return false;

    anchor.insertAdjacentElement('afterend', btn);
    return true;
  }

  reposition();

  if (typeof MutationObserver !== 'function') return;

  var observer = new MutationObserver(function () { reposition(); });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  setTimeout(function () { observer.disconnect(); }, 30000);
})();
